var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpencv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    rx: 10,
    fill: "#FF4D61"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.484 22.207C37.7293 10.4407 54.4597 9.82324 61.5263 21.0983C67.0023 29.8354 63.5203 40.68 55.4815 45.3488L50.2608 36.3063C53.4589 34.4489 54.8441 30.1346 52.6656 26.6588C49.8543 22.1733 43.1985 22.4189 40.7139 27.0998C38.8754 30.5636 40.3325 34.5505 43.3601 36.3107L38.1356 45.3599C30.5251 40.9352 26.8625 30.9138 31.484 22.207ZM34.2764 64.6134C34.2701 68.1223 31.5397 71.3916 27.6146 71.5364C22.3187 71.7319 18.7855 66.0946 21.2701 61.4136C23.1912 57.7943 27.6049 56.8292 30.8081 58.6498L36.0425 49.5835C27.9886 44.9876 16.8741 47.4135 12.0401 56.5207C5.79476 68.287 14.676 82.4573 27.988 81.966C37.836 81.6026 44.6922 73.4148 44.7335 64.6134H34.2764ZM75.2868 49.6235L70.0662 58.666C73.2751 60.5184 74.6683 64.8411 72.4863 68.3225C69.675 72.8081 63.0192 72.5624 60.5346 67.8815C58.693 64.4118 60.1581 60.4174 63.1962 58.6617L57.9717 49.6125C50.3508 54.0327 46.6801 64.0617 51.3047 72.7743C57.55 84.5406 74.2804 85.1581 81.347 73.8831C86.8265 65.1404 83.3365 54.2874 75.2868 49.6235Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpencv);
export default __webpack_public_path__ + "static/media/opencv.2da44b980d50da038e3c5e7d8cdc7d57.svg";
export { ForwardRef as ReactComponent };